export class MarketTrackingEvents {
  static readonly Home = {
    Visit: "home-visit",
    // not using this for now. too granular for soft launch - JL
    // SearchSuggestSelect: "home-search-suggest-select",
    // JobStartDateSelect: "home-job-start-date-select",
    // JobDurationSelect: "home-job-duration-select",
    SearchButtonClick: "home-search-btn-click", // properties: searchTerm, job start date, job duration

    ExploreCardClick: "home-explore-card-click", // properties: category
    HowItWorksVideoButtonClick: "home-how-it-works-video-btn-click",
    HowItWorksLearnMoreButtonClick: "home-how-it-works-learn-more-btn-click",
    ListYourMachinesButtonClick: "home-list-your-machines-btn-click",
    RfqSubmitted: "home-rfq-submitted", // properties: rentalLength, fileType
  };

  static readonly EarningsCalculator = {
    Visit: "earnings-calculator-visit",
    PhotoSelected: "earnings-calculator-photo-selected",
    MachineIdentified: "earnings-calculator-machine-identified", // AI found the machine
    MachineNotIdentified: "earnings-calculator-machine-not-identified", // AI could not identify the machine
    LeadSubmitted: "earnings-calculator-lead-submitted",
  };

  static readonly Hauling = {
    Visit: "hauling-visit",
    LeadSubmitted: "hauling-lead-submitted",
  };

  static readonly ServiceProvider = {
    Visit: "service-provider-visit",
    LeadSubmitted: "service-provider-lead-submitted",
  };

  static readonly ConnectMachines = {
    Visit: "connect-machines-visit",
    LeadSubmitted: "connect-machines-lead-submitted",
  };

  static readonly Search = {
    // search
    Header: "search-header", // properties: searchTerm
    SimpleSearch: "search-simple-search", // properties: searchTerm
  };

  static readonly SearchResults = {
    Visit: "search-results-visit",
  };

  static readonly SearchResult = {
    Click: "search-result-click", // properties: inventoryId
    ListViewClick: "search-result-list-view-click",
  };

  static readonly MachineDetails = {
    Visit: "machine-details-visit", // properties: inventoryId
  };

  static readonly Cart = {
    InitialAddToCartClick: "cart-initial-add-to-cart-click", // properties: inventoryId
    TryAddItem: "cart-try-add-item", // properties: inventoryId
    ItemAdded: "cart-item-added", // properties: inventoryId
    TryRemoveItem: "cart-try-remove-item", // properties inventoryId
    ItemRemoved: "cart-item-removed", // properties: inventoryId
    CartDeleted: "cart-deleted",
    Opened: "cart-opened",
    Closed: "cart-closed",
    CheckoutClick: "cart-checkout-click",
    DiscountOfferShown: "cart-discount-offer-shown", // anonymous 10%-off phone popup displayed
    DiscountOfferClaimed: "cart-discount-offer-claimed", // coupon minted + applied via the popup
    ShareOpened: "cart-share-opened", // Share button clicked, share popup displayed
    Shared: "cart-shared", // share SMS or email successfully queued. properties: cartId, channel
    SharedLinkOpened: "cart-shared-link-opened", // recipient opened a texted cart link. properties: cartId
  };

  static readonly Checkout = {
    Review: "review",
    Coverage: "coverage",
    Transportation: "transportation",
    Terms: "terms",
    CreditCheck: "credit check",
    Pay: "pay",
    Verification: "verification",
    Complete: "complete",
  };
}
